import { goto } from '$app/navigation'
import type { Language } from '@bond/components'

export function changeLanguage(event: Event, url: URL) {
  const select = event.target as HTMLSelectElement | null
  const newLang = select?.value as Language | undefined

  if (newLang) {
    const oldLang = document.documentElement.lang
    document.documentElement.lang = newLang
    goto(url.pathname.replace(oldLang, newLang), { noScroll: true })
  }
}
